/* Inspiration Hub — vanilla JS for:
   - Jump-nav smooth scroll (hero pills + range CTAs)
   - Hero category pills routed to Article Tabs section (tab activation)
   - Deep-link tab activation from URL hash on load
   - Horizontal range-gallery scroll buttons
   - FAQ accordion with aria-expanded toggle
   Runs on DOMContentLoaded; safe to load with `defer`. */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function handleize(s) {
    return (s || '')
      .toString()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getTabsRoot() {
    return document.querySelector('[data-article-tabs]');
  }

  function getTabsScrollTarget(tabsRoot) {
    return (tabsRoot && tabsRoot.closest('[id^="shopify-section-"]')) || tabsRoot;
  }

  function activateTab(tabsRoot, handle) {
    if (!tabsRoot || !handle) return false;
    var btn = tabsRoot.querySelector('[data-tab-id="' + handle + '"]');
    if (!btn) return false;
    btn.click();
    return true;
  }

  /* Re-route hero category pills to the Article Tabs section when present.
     If a pill's label matches a tab's data-tab-id, the pill triggers that tab
     and scrolls to the tabs section instead of doing its hash jump. Pills with
     no matching tab keep their original jump-nav behaviour (handled by
     wireJumpNav below). */
  function wireCategoryPillsToArticleTabs() {
    var tabsRoot = getTabsRoot();
    if (!tabsRoot) return;

    document.querySelectorAll('.hero-cats a').forEach(function (pill) {
      var label = (pill.textContent || '').trim();
      var handle = handleize(label);
      if (!handle) return;
      var tabBtn = tabsRoot.querySelector('[data-tab-id="' + handle + '"]');
      if (!tabBtn) return;

      /* Strip data-jump so wireJumpNav skips this pill. */
      pill.removeAttribute('data-jump');

      pill.addEventListener('click', function (e) {
        e.preventDefault();
        activateTab(tabsRoot, handle);
        var scrollEl = getTabsScrollTarget(tabsRoot);
        if (scrollEl) scrollEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + handle);
      });
    });
  }

  /* On page load, if the URL hash matches a tab handle, activate that tab and
     scroll to the section. Lets you share/bookmark deep links like
     /blogs/inspiration#curtains. */
  function handleDeepLink() {
    var tabsRoot = getTabsRoot();
    if (!tabsRoot) return;
    var hash = (location.hash || '').replace(/^#/, '');
    if (!hash) return;
    if (!activateTab(tabsRoot, hash)) return;
    var scrollEl = getTabsScrollTarget(tabsRoot);
    if (!scrollEl) return;
    /* Defer one frame so layout (images, fonts) settles before scroll. */
    setTimeout(function () {
      scrollEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
  }

  function wireJumpNav() {
    document.querySelectorAll('[data-jump]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var href = el.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var id = href.slice(1);
        var target = id && document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + id);
      });
    });
  }

  function wireScrollers() {
    document.querySelectorAll('.scroll-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-scroll-target');
        var dir = parseInt(btn.getAttribute('data-dir'), 10) || 1;
        var el = id && document.getElementById(id);
        if (!el) return;
        el.scrollBy({ left: dir * el.clientWidth * 0.7, behavior: 'smooth' });
      });
    });
  }

  function wireFaq() {
    document.querySelectorAll('.faq-item').forEach(function (item) {
      var btn = item.querySelector('.faq-q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(isOpen));
      });
    });
  }

  function wireAll() {
    /* Order matters: pills->tabs strips data-jump from re-routed pills before
       wireJumpNav reads the [data-jump] selector. */
    wireCategoryPillsToArticleTabs();
    wireJumpNav();
    wireScrollers();
    wireFaq();
  }

  ready(function () {
    wireAll();
    handleDeepLink();
  });

  /* Shopify theme editor — re-wire when a section is dynamically re-rendered */
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', wireAll);
  }
})();
